import { Flyout } from "@/components/General/Flyout/flyout";
import { WishlistModel } from "@/redux/modules/api/data/wishlist/@types/wishlist.model";

import { WishlistListContainer } from "./WishlistList/WishlistList.container";

export type WishlistSidebarComponentProps = {
    isVisible: boolean;
    isMobileMode: boolean;
    wishlists: Array<WishlistModel>;
    onToggle: () => void;
};

export const WishlistSidebarComponent = ({
    wishlists,
    onToggle,
    isMobileMode,
    isVisible
}: WishlistSidebarComponentProps) => {
    if (!isMobileMode && isVisible) {
        return (
            <WishlistListContainer
                wishlists={wishlists}
                isMobile={isMobileMode}
            />
        );
    }

    return (
        <Flyout
            open={isVisible}
            onClose={onToggle}
        >
            <Flyout.Content>
                <WishlistListContainer
                    wishlists={wishlists}
                    isMobile={isMobileMode}
                />
            </Flyout.Content>
            <Flyout.Controls>
                <Flyout.Controls.CloseButton />
            </Flyout.Controls>
        </Flyout>
    );
};
